<template>
  <div class="accordian">
    <div class="accordian__header" @click.prevent="onCardToggle">
      <div class="accordian__header__left-block">
        <slot name="accordian-header-content"></slot>
      </div>
      <div class="accordian__header__right-block">
        <span v-if="!expanded" class="mi-24px mi-chevron-down"></span>
        <span v-else class="mi-24px mi-chevron-up"></span>
      </div>
    </div>
    <slot v-if="expanded" name="accordian-body"></slot>
  </div>
</template>

<script>

export default {
    name: 'Accordian',
    props: {
        expanded: { type: Boolean, default: false },
        background: {type: String, default: 'var(--Gray-100)'},
        item: {type: Object, default: null},
        index: {type: Number, default: null}
    },
    methods: {
        onCardToggle () {
            this.$emit("onCardToggle", this.item, this.index);
        }
    }
    
}
</script>

<style lang="scss" scoped>
@import "../../styles/imports";
.accordian{
    &__header {
      background: var(--Gray-100);
      border-radius: 0.25rem;
      padding: 1rem;
      margin-left: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      @include media("<tablet") {
        margin-left: 40px;
      }

      &__left-block {
        display: flex;
        align-items: center;

        @include media("<tablet") {
          flex-direction: column;
        }
      }
    }
}
</style>